import React, { useEffect, useState } from 'react';
import { LayoutGroup, motion } from 'motion/react';
import RotatingText from '../RotatingText';

const API = 'https://yurinkov.dev/msg.php';
const LEADERBOARD_API = 'https://yurinkov.dev/api/leaderboard?game=ktoksazal';
const SAVE_SCORE_API = 'https://yurinkov.dev/api/save-score';

const MAX_ROUNDS = 20;
const MAX_SCORE = MAX_ROUNDS * 30;

const TWITCH_CLIENT_ID = '2gca3zcuwpdegutj1wiwurgzwu98gn'; // ← Replace

function KtoksazalPage() {
  const [quotes, setQuotes] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [round, setRound] = useState(0);
  const [score, setScore] = useState(0);
  const [current, setCurrent] = useState(null);
  const [choices, setChoices] = useState([]);
  const [choiceStates, setChoiceStates] = useState({});
  const [attempts, setAttempts] = useState(0);
  const [locked, setLocked] = useState(false);

  const [leaderboard, setLeaderboard] = useState([]);
  const [twitchUser, setTwitchUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load data
  useEffect(() => {
    const loadData = async () => {
      try {
        const [msgRes, lbRes] = await Promise.all([
          fetch(API),
          fetch(LEADERBOARD_API)
        ]);

        const msgData = await msgRes.json();
        const msgs = (msgData.messages || []).filter(m => m.text && m.text.length > 40);

        setQuotes(msgs);
        setAllUsers([...new Set(msgs.map(m => m.user).filter(Boolean))]);

        const lbData = await lbRes.json();
        setLeaderboard(lbData.top || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // Handle Twitch callback
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const twitchLogin = params.get('twitch_login');
    const twitchDisplay = params.get('twitch_display');

    if (twitchLogin) {
      setTwitchUser({
        login: twitchLogin,
        display_name: twitchDisplay || twitchLogin
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const loginWithTwitch = () => {
    const redirectUri = encodeURIComponent('https://yurinkov.dev/auth/twitch/callback');
    const authUrl = `https://id.twitch.tv/oauth2/authorize?` +
      `client_id=${TWITCH_CLIENT_ID}&` +
      `redirect_uri=${redirectUri}&` +
      `response_type=code&` +
      `scope=user:read:email`;
    window.location.href = authUrl;
  };

  const shuffle = (arr) => {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };

  const next = (forceStart = false) => {
    if (!forceStart && (round >= MAX_ROUNDS || quotes.length === 0)) {
      setRound(MAX_ROUNDS);
      return;
    }

    const q = quotes[Math.floor(Math.random() * quotes.length)];
    const incorrect = shuffle(allUsers.filter(u => u && u !== q.user)).slice(0, 2);
    const options = shuffle([q.user, ...incorrect]);

    setCurrent(q);
    setChoices(options);
    setChoiceStates(Object.fromEntries(options.map(u => [u, 'idle'])));
    setAttempts(0);
    setLocked(false);
    setRound(r => (forceStart ? 1 : r + 1));
  };

  const restartGame = () => {
    setRound(0);
    setScore(0);
    setCurrent(null);
    setChoices([]);
    setChoiceStates({});
    setAttempts(0);
    setLocked(false);
    next(true);
  };

  // SAFE choose function
  const choose = (user) => {
    if (!current || locked) return;
    if (!current.user) {
      console.warn("current.user is undefined");
      return;
    }

    const isCorrect = user === current.user;

    if (isCorrect) {
      const points = attempts === 0 ? 30 : attempts === 1 ? 15 : 1;
      setChoiceStates(prev => ({ ...prev, [user]: 'correct' }));
      setScore(s => s + points);
      setLocked(true);
      setTimeout(next, 1500);
      return;
    }

    setChoiceStates(prev => ({ ...prev, [user]: 'wrong' }));
    setAttempts(prev => {
      const updated = prev + 1;
      if (updated >= 3) {
        setLocked(true);
        setChoiceStates(prevStates => ({ ...prevStates, [current.user]: 'correct' }));
        setTimeout(next, 1500);
      }
      return updated;
    });
  };

  const saveResult = async () => {
    if (!twitchUser) return;

    try {
      const res = await fetch(SAVE_SCORE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          game: 'ktoksazal',
          username: twitchUser.login,
          display_name: twitchUser.display_name,
          score
        })
      });

      if (res.ok) {
        alert(`✅ Результат ${score} сохранён!`);
        const lbRes = await fetch(LEADERBOARD_API);
        const lbData = await lbRes.json();
        setLeaderboard(lbData.top || []);
      }
    } catch (err) {
      alert("Ошибка при сохранении");
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-white">
      <LayoutGroup>
        <motion.p className="flex items-center gap-2 text-6xl font-extrabold tracking-tight -mt-12 md:-mt-16 lg:-mt-20 mb-12 z-20" layout>
          <motion.span layout>PESPATRON44</motion.span>
          <RotatingText
            texts={['rus', 'наш', 'zzz', 'дракон', 'круТАЯ', 'страпон']}
            mainClassName="px-3 sm:px-3 md:px-4 overflow-hidden py-1 sm:py-1 md:py-2 justify-center rounded-lg bg-gradient-to-r from-indigo-500/75 via-purple-500/75 to-pink-500/75 text-white shadow-lg"
            staggerFrom="last"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-120%" }}
            staggerDuration={0.025}
            splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
            transition={{ type: "spring", damping: 30, stiffness: 400 }}
            rotationInterval={2000}
          />
        </motion.p>
      </LayoutGroup>

      <div className="w-full max-w-6xl grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Game Area */}
        <div className="lg:col-span-7">
          <div className="bg-gradient-to-br from-black/60 to-black/40 backdrop-blur-md border border-white/10 rounded-3xl p-6 shadow-2xl text-center">
            <h2 className="text-2xl font-bold mb-2">Кто сказал?</h2>

            <div className="text-sm text-gray-400 mb-6">
              Раунд: {Math.min(round, MAX_ROUNDS)}/{MAX_ROUNDS} — 
              Очки: <span className="text-white font-semibold">{score}</span> / {MAX_SCORE}
            </div>

            {round >= MAX_ROUNDS ? (
              <div className="mt-6 rounded-2xl border border-white/10 bg-black/40 p-8">
                <p className="text-2xl font-semibold">Игра окончена!</p>
                <p className="text-5xl font-bold text-white mt-4 mb-8">
                  {score} / {MAX_SCORE}
                </p>

                {!twitchUser ? (
                  <button
                    onClick={loginWithTwitch}
                    className="w-full flex items-center justify-center gap-3 bg-[#9146FF] hover:bg-[#772CE8] py-4 rounded-2xl text-lg font-semibold transition mb-4"
                  >
                    🔗 Войти через Twitch и сохранить результат
                  </button>
                ) : (
                  <button
                    onClick={saveResult}
                    className="w-full flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 py-4 rounded-2xl text-lg font-semibold transition mb-4"
                  >
                    💾 Сохранить результат ({twitchUser.display_name})
                  </button>
                )}

                <button
                  onClick={restartGame}
                  className="w-full py-3 bg-white/10 hover:bg-white/20 rounded-2xl text-sm font-semibold transition"
                >
                  Играть снова
                </button>
              </div>
            ) : current ? (
              <>
                <div className="mb-6 italic bg-gray-900/80 p-6 rounded-2xl text-left text-lg leading-relaxed border border-white/10 min-h-[140px] flex items-center">
                  "{current.text}"
                </div>

                <div className="flex flex-col gap-3">
                  {choices.map(u => {
                    const state = choiceStates[u] || 'idle';
                    return (
                      <button
                        key={u}
                        className={`w-full px-5 py-3.5 rounded-2xl border transition-all text-left font-medium ${
                          state === 'correct' 
                            ? 'border-emerald-400 bg-emerald-500/20 text-emerald-100' 
                            : state === 'wrong' 
                              ? 'border-rose-400 bg-rose-500/20 text-rose-100' 
                              : 'border-white/10 hover:bg-white/5 hover:border-white/30'
                        } ${locked && state !== 'correct' ? 'opacity-60 cursor-not-allowed' : ''}`}
                        onClick={() => choose(u)}
                        disabled={locked}
                      >
                        {u}
                      </button>
                    );
                  })}
                </div>
              </>
            ) : (
              <button
                onClick={() => next(true)}
                className="mt-8 px-12 py-4 bg-indigo-600 hover:bg-indigo-500 rounded-2xl text-xl font-semibold transition transform hover:scale-105"
              >
                Начать игру
              </button>
            )}
          </div>
        </div>

        {/* Leaderboard */}
        <div className="lg:col-span-5">
          <div className="bg-gradient-to-br from-black/60 to-black/45 border border-white/10 rounded-3xl p-6 shadow-2xl text-left h-full">
            <h3 className="text-xl font-semibold mb-4">👑 Топ-10 Ktoksazal</h3>
            <div className="space-y-2 max-h-[520px] overflow-y-auto pr-1 hide-scrollbar" style={{ msOverflowStyle: 'none' }}>
              {leaderboard.length > 0 ? (
                leaderboard.map((entry, i) => (
                  <div key={i} className="flex items-center justify-between rounded-2xl bg-white/5 border border-white/10 px-4 py-2">
                    <span className="text-white/90 text-sm">
                      {i + 1}. {entry.display_name || entry.username}
                    </span>
                    <span className="text-white/60 text-sm font-mono">{entry.score}</span>
                  </div>
                ))
              ) : (
                <p className="text-white/50 text-sm py-12 text-center">
                  {loading ? "Загрузка..." : "Пока нет результатов"}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KtoksazalPage;